(() => {
  const addBusinessDays = (startDate, days) => {
    const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }

    return date;
  };

  const formatRange = (minDate, maxDate) => {
    const sameMonth = minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear();
    const day = (date) => date.toLocaleDateString('en-GB', { day: 'numeric' });
    const month = (date) => date.toLocaleDateString('en-GB', { month: 'short' });

    if (sameMonth) return `${day(minDate)}–${day(maxDate)} ${month(maxDate)}`;
    return `${day(minDate)} ${month(minDate)}–${day(maxDate)} ${month(maxDate)}`;
  };

  const updateDeliveryDates = (root = document) => {
    root.querySelectorAll('[data-lhc-cart-delivery]').forEach((output) => {
      const minDays = Number.parseInt(output.dataset.minDays, 10);
      const maxDays = Number.parseInt(output.dataset.maxDays, 10);
      if (!Number.isFinite(minDays) || !Number.isFinite(maxDays) || maxDays < minDays) return;

      const range = formatRange(addBusinessDays(new Date(), minDays), addBusinessDays(new Date(), maxDays));
      if (output.textContent.trim() !== range) output.textContent = range;
    });
  };

  const drawer = document.querySelector('cart-drawer');
  updateDeliveryDates();

  if (drawer) {
    new MutationObserver(() => updateDeliveryDates(drawer)).observe(drawer, {
      childList: true,
      subtree: true
    });
  }
})();

(() => {
  const cloneNativePayPalIcon = () => {
    const source = document.querySelector('svg[aria-labelledby="pi-paypal"]');
    if (!source) return null;

    const svg = source.cloneNode(true);
    svg.removeAttribute('aria-labelledby');
    svg.setAttribute('aria-hidden', 'true');
    svg.querySelector('title')?.remove();
    svg.classList.remove('icon', 'icon--full-color');
    svg.classList.add('lhc-cart-payments__icon');
    return svg;
  };

  const ensurePayPalIcon = () => {
    const list = document.querySelector('cart-drawer .lhc-cart-payments ul');
    if (!list || list.querySelector('[data-lhc-paypal-icon]')) return;

    const svg = cloneNativePayPalIcon();
    if (!svg) return;

    const item = document.createElement('li');
    item.dataset.lhcPaypalIcon = 'true';
    item.appendChild(svg);

    const label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = 'PayPal';
    item.appendChild(label);
    list.appendChild(item);
  };

  const initialize = () => {
    ensurePayPalIcon();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    new MutationObserver(ensurePayPalIcon).observe(drawer, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
